import React from 'react';
const CollapseContext = /*#__PURE__*/React.createContext({});
export default CollapseContext;